import { useEffect } from "react";

const WhatsAppConversionTracker = () => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a");
      if (!anchor) return;

      const href = anchor.getAttribute("href") || "";
      if (!href.includes("wa.me")) return;

      // Prevent default to allow gtag callback to handle navigation
      e.preventDefault();

      const gtag = (window as any).gtag;
      if (typeof gtag === "function") {
        gtag("event", "conversion", {
          send_to: "AW-17972804983/tBgaCLuh9f0bEPf6jPpC",
          value: 1.0,
          currency: "BRL",
          event_callback: () => {
            window.open(href, anchor.target || "_blank");
          },
        });
        // Fallback: if gtag doesn't callback in 1s, navigate anyway
        setTimeout(() => {
          window.open(href, anchor.target || "_blank");
        }, 1000);
      } else {
        // gtag not loaded, just navigate
        window.open(href, anchor.target || "_blank");
      }
    };

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return null;
};

export default WhatsAppConversionTracker;
